// File: src/pages/Recipes.js
import React from "react";
import { Helmet } from "react-helmet";
import "./Recipes.css";

// Each recipe is a self-contained static cook-mode page in public/recipes/,
// so the links are plain <a> tags, not router links.
const recipeItems = [
  {
    title: "Loaded Sweet Potatoes with Chipotle Beef and Bacon",
    description:
      "Steamed, then charred sweet potatoes under garlic herb labneh, crusty chipotle beef, bacon and hot honey. For 2, 45 to 50 minutes.",
    href: "/recipes/loaded-sweet-potatoes",
  },
  {
    title: "Fiery Chicken Tom Yum",
    description:
      "Very spicy Thai hot and sour chicken soup with lemongrass, galangal, lime leaves and lime at the end. For 5 big bowls, 35 to 40 minutes.",
    href: "/recipes/fiery-chicken-tom-yum",
  },
];

export default function Recipes() {
  return (
    <div className="recipes-container">
      <Helmet>
        <title>Recipes | Helia Jamshidi</title>
        <meta
          name="description"
          content="Recipes Helia cooks, written as cook-mode pages with checklists, timers and a heat guide."
        />
        <meta property="og:title" content="Recipes | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Cook-mode recipe pages with checklists, timers and a heat guide."
        />
        <meta property="og:url" content="https://heliajamshidi.me/recipes" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/recipes" />
      </Helmet>
      <h2>Recipes</h2>
      <p>
        Dishes I cook, written as cook-mode pages: tick off the shopping list,
        start timers from each step, and keep the screen on while you cook.
      </p>
      <ul className="recipe-list">
        {recipeItems.map((it) => (
          <li key={it.href} className="recipe-item">
            <a href={it.href} className="recipe-link">{it.title}</a>
            <p className="recipe-description">{it.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
